module.exports = "pegasus/assets/background-patterns/wooden-wall.png";